import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae1c1a90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-bg" }, null, -1))
const _hoisted_3 = { class: "home-wrapper" }
const _hoisted_4 = { class: "home" }
const _hoisted_5 = { class: "m-main-section" }
const _hoisted_6 = { class: "m-main-content" }
const _hoisted_7 = { class: "m-paper" }
const _hoisted_8 = {
  key: 1,
  class: "m-paper-list"
}
const _hoisted_9 = {
  key: 0,
  class: "m-pagination-seaction"
}
const _hoisted_10 = { class: "m-slide" }
const _hoisted_11 = { class: "rank" }

import { ref, reactive, onMounted, watch, computed, nextTick  } from "vue";
import { isSameDay } from '@/utils/utils';
import Search from "@/components/paper/search-component.vue";
import Banner from "@/components/paper/home-banner.vue";
import Filter from "@/components/paper/filter-component.vue";
import deaultDictionary from "./dictionary.json";
import defaultGradeInfo from "./grade.json";
import RankList from "../../components/singlePaper/rankList.vue";
import UserMember from '@/components/user/userMember.vue'
import {
  pvPctestpaperBlankBlank,
  showPctestpaperPopupBlank,
  clickPctestpaperPopupSee,
  clickPctestpaperPopupClose,
  clickPctestpaperMarketBlank,
  clickPctestpaperScreenBlank,
  clickPctestpaperStreamPaper,
  clickPctestpaperEliteschoolPaper
} from '@/trace/xesTackHome'

import { queryExampaperList, queryMultiDetail, queryGradeList, queryDictionaryList, queryPopConfig } from '@/api/index'
import paperItem from '@/components/paper/PaperItem.vue'
import MultiPaperDetail from '@/components/paper/MultiPaperDetail.vue'
import { IPaperItem } from '@/interface/paper';
import NoData from "@/components/pub/NoData.vue";
import LoadWrong from "@/components/pub/LoadWrong.vue";
import { useRouter } from "vue-router";
import {Departion} from '@/const/paper';

import { isLogin } from '@/utils/utils'
import { ServiceStatusType } from '@/const/user'

import ExpireLottie from "@/components/paper/ExpireLottie.vue";
import { useStore } from "vuex";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'homePage',
  setup(__props) {

const store = useStore()
const router = useRouter();
const currentPage = ref(0)
const maxPage = ref(1)
const pageSize = ref(10)
const total = ref(1)
const noData = ref(false)
const loadWrong = ref(false)
const isLoading = ref(true)
const showBanner = ref(false)
const layout = computed(() => {
  if (currentPage.value === 1) {
    return 'pager, next, jumper'
  } else if (currentPage.value === maxPage.value) {
    return 'prev, pager, jumper'
  } else {
    return 'prev, pager, next, jumper'
  }
})
const users = computed(() => store.state.user.userInfo)
const paperVipInfo = computed(() => store.getters['user/paperVipInfo'])
const vip = computed(
  () => paperVipInfo.value?.use_status === ServiceStatusType['已开通']
)

const paperList = ref([]) // 试卷列表
const packInitInfo = {
  title: '',
  paper_num: 0,
  detail: ''
}
const showMultiPaperDetail = ref(false)
const packPaperList = ref([]) // 套卷列表
const packPaperInfo = reactive(packInitInfo) // 套卷详情

const gradeList = ref([]);
const selectedSubject = ref({}); // 选中的学部学科
const finalQueryParams = ref({});
const defaultSubject = ref({}); // 默认小学数学
const defaultKeyWord = ref("");
const gradeClassifyDefault = ref({}); // 默认年级和试卷分类
const gradesJy = ref([]); // 年级列表
const dictionary = ref({}); // 字典

const divisionidMap = {
  1: "subjectPrimary",
  2: "subjectJunior",
  3: "subjectSenior",
};

const expireInfo = ref({}); // 临期弹窗


const userInfo = ref({}) ;// userid

// 埋点数据
const traceInfo = () => {
  let {equit_status,equit_scene} = expireInfo.value
  let papervipstatus = ''
  if(equit_status === -1){
    papervipstatus = '未购买会员'
  }else if(equit_status === 1){
    papervipstatus = '会员'
  }else if(equit_status === 0){
    papervipstatus = '过期会员'
  }
  return {
    papervipstatus,
    content:equit_status === 1 ? `临期${equit_scene}天弹窗`: '过期弹窗',
    sourceclient: 'pc'
  }
}
// url参数解析
const {
  divisionId: outDivisionId = "",
  subject: outSubject,
  from = "",
  keyword: outKeyword = "",
  grade: outGrade,
  classify: outClassify,
} = router.currentRoute.value.query;
//先从本地取from 参数 如果有的话就不存
if (from) {
  window.sessionStorage.setItem("originFrom", from as string);
}



// 搜索切换选择学科
const handleSelectSubject = (subject, type) => {
  // 学部缓存到本地
  window.localStorage.setItem("divisionId", JSON.stringify(subject.divisionId));
  selectedSubject.value = { ...subject, type };
  gradeList.value = gradesJy.value?.filter(
    (item) => item.division_id === selectedSubject.value.divisionId
  );
};
const paramsChangeListenter = (params, type, paramsName) => {
  console.log(params, type, paramsName, 'paramsChangeListenter');

  if(type === 'select') {
    clickPctestpaperScreenBlank({
      screen_name: paramsName.map(item => item.screen).join(','),
      content: paramsName.map(item => item.content).join(','),
      is_login: userInfo.value ? '是' : '否',
      is_vip: vip.value ? '是' : '否',
    })
  }
  let receiveParams = JSON.parse(JSON.stringify(params))
  if(gradeClassifyDefault.value?.grade === -1) {
    delete gradeClassifyDefault.value.grade
  }
  if(gradeClassifyDefault.value?.classify === '-1') {
    delete gradeClassifyDefault.value.classify
  }
  if (type === "load") {
    finalQueryParams.value = {
      ...gradeClassifyDefault.value,
      ...receiveParams,
      key_word: defaultKeyWord.value,
      subject: selectedSubject.value?.value,
      grade_group_id: selectedSubject.value?.divisionId,
    };
  } else {
    finalQueryParams.value = {
      ...receiveParams,
      key_word: defaultKeyWord.value,
      subject: selectedSubject.value?.value,
      grade_group_id: selectedSubject.value?.divisionId,
    };
  }
  getPaperList()
};
// 点击搜索
const handleSearch = (searchVal:string) => {
  defaultKeyWord.value = decodeURIComponent(searchVal);
  finalQueryParams.value = {
    ...finalQueryParams.value,
    key_word: defaultKeyWord.value,
  };
  getPaperList()
};
// 默认参数的初始化
const handleDefaultFilters = () => {
  let divisionId = 1;
   // 是否从4大网站来

  // const originFrom = window.localStorage.getItem("originFrom")
  // console.log(originFrom, 'originFromoriginFrom', outDivisionId)
  // 学部默认
  if (outDivisionId) {
    divisionId = Number(outDivisionId)
  } else {
    if (
      from === "gaokao.com" ||
      from === "zhongkao.com" ||
      from === "aoshu.com" ||
      from === "zuowen.com"
    ) {
      switch (from) {
        case "gaokao.com":
          divisionId = 3;
          break;
        case "zhongkao.com":
          divisionId = 2;
          break;
        case "aoshu.com":
          divisionId = 1;
          break;
        case "zuowen.com":
          divisionId = 1;
          break;
      }
    } else {
      if (window.localStorage.getItem("divisionId")) {
        divisionId = Number(window.localStorage.getItem("divisionId"))
      } else {
        divisionId = 1;
      }
    }

  }
  // 学部缓存到本地
  window.localStorage.setItem("divisionId", JSON.stringify(divisionId));
  // 学科默认
  if (outSubject) {
    defaultSubject.value = {
      id: outSubject,
      text: dictionary.value?.subject[divisionidMap[divisionId]]?.find(
        (item) => item.value === outSubject
      )?.text,
      value: outSubject,
      divisionId: Number(divisionId),
    };
  } else {
    if (from === "zuowen.com") {
      defaultSubject.value = {
        id: "1",
        text: "语文",
        value: "1",
        divisionId: Number(divisionId),
      };
    } else {
      defaultSubject.value = {
        id: "2",
        text: "数学",
        value: "2",
        divisionId: Number(divisionId),
      };
    }
  }
  // 搜索关键词
  // defaultKeyWord.value = decodeURIComponent(outKeyword as string);


  // 年级和试卷类型默认
  gradeClassifyDefault.value = {
    grade: Number(outGrade) || -1,
    classify: outClassify || '-1',
  };

  let gradename
  if(outGrade && outGrade !== -1) {
    const grade = gradesJy.value.find((grade) => grade.id === Number(outGrade))
    gradename = grade?.name
  } else {
    gradename = '全部'
  }
  // 试卷宝pv
  pvPctestpaperBlankBlank({
    departion: Departion[divisionId],
    area:'全国',
    class: gradename
  })
};
// 查询试卷列表
const getPaperList = (curPage=0) => {
  isLoading.value = true
  noData.value = false
  loadWrong.value = false
  if (!curPage) {
    currentPage.value = 0
  }
  queryExampaperList({
    ...finalQueryParams.value,
    page_info: {
      limit: pageSize.value,
      page: curPage || currentPage.value + 1
    }
  }).then(res => {
    const { list = [], page_info = {} } = res?.data || {}
    let { max_page = 0, page = 0 } = page_info || {}
    maxPage.value = max_page
    currentPage.value = page
    total.value = max_page * pageSize.value
    isLoading.value = false
    if (!list?.length) {
      paperList.value = []
      nextTick(() => {
        noData.value = true
      })
    } else {
      paperList.value = list
    }
  }).catch(err => {
    isLoading.value = false
    nextTick(() => {
      loadWrong.value = true
    })
    console.log(err)
  })
}
// 当前页码切换
const handleCurrentChange = () => {
  getPaperList(currentPage.value)
}
// 套卷查询
const getMultiDetail = (id) => {
  if (!id) {
    // 数据错误
    return
  }
  packPaperList.value = []
  Object.assign(packPaperInfo, packInitInfo)
  queryMultiDetail({
    pack_unionid: id
  }).then(res => {
    const {info, pack_paper_content: list} = res.data
    packPaperList.value = list || []
    Object.assign(packPaperInfo, info || {})
    showMultiPaperDetail.value = true
  }).catch(err => {
    console.log(err)
  })
}
// 关闭套卷弹窗
const handleCloseMultiPaperDetail = () => {
  showMultiPaperDetail.value = false
}
// 查看试卷/套卷详情
const handleItemClick = (item: IPaperItem) => {
  console.log(item, 'item')

  if (item.paper_type === 1) {
    // 单卷跳转
    const url = router.resolve(
      {
      path: 'single-paper',
        query: {
          'paper_id': item.id,
          'entrance': '试卷宝主页'
        }
      }
    );
    window.open(url.href, '_blank');
    clickPctestpaperStreamPaper({
        paper_id: item.id,
        paper_name: item.name,
        is_login: userInfo.value ? '是' : '否',
        is_vip: vip.value ? '是' : '否',
    })
  } else {
    // 套卷弹窗
    const { id } = item
    getMultiDetail(id)

  }
}
const onRankDetail = (item) => {
  clickPctestpaperEliteschoolPaper({
      paper_id: item.id,
      paper_name: item.name,
      is_login: userInfo.value ? '是' : '否',
      is_vip: vip.value ? '是' : '否',
  })
}

const getGradeAndDictionaryData = async () => {
  // 获取字典数据
  try {
    const dictionaryData = await queryDictionaryList();
    dictionary.value = dictionaryData?.data || deaultDictionary?.data;

  } catch (error) {
    console.log(error);
    dictionary.value = deaultDictionary.data
  }

  // 获取年级数据
  try {
    const resGrade = await queryGradeList();
    const gradeInfo = resGrade?.data || defaultGradeInfo?.data;
    gradesJy.value = gradeInfo?.gradesJy;
  } catch (error) {
    console.log(error);
    gradesJy.value = defaultGradeInfo.data?.gradesJy
  }

  // 默认参数的初始化
  handleDefaultFilters();
  // 初始化搜索 学科和学部搜索query参数
  handleSelectSubject(defaultSubject.value, "load")
}
const canShowDialog = ref(false)

// 每天/每7展示一次
const isTodayOrWeekCanShow = frequencyType => {
    const stayPop = localStorage.getItem('remindPop') && JSON.parse(localStorage.getItem('remindPop'));
    if (stayPop) {
        if (stayPop?.frequency === frequencyType
            && stayPop?.userId === userInfo?.value?.userid && isSameDay(stayPop?.showTime)) {
            return false;
        }
    }
    return true;
};

// 提示弹窗
const isShowRemindPopByFrequency = () => {
    // 挽留弹窗展示频次：1-每次展示 2-每天展示一次 3-每7天展示一次
    const frequency = expireInfo.value?.frequency;
    canShowDialog.value = isTodayOrWeekCanShow(frequency);
    return isTodayOrWeekCanShow(frequency)
}

// 是否可以展示提示弹窗
const isShowRemindPop = () => {
    if (canShowDialog.value && isShowRemindPopByFrequency()) {
      
        // 记录弹窗展示
        localStorage.setItem('remindPop', JSON.stringify({
            frequency: expireInfo.value?.frequency,
            userId: userInfo?.value?.userid,
            showTime: Date.parse(new Date()) / 1000,
        }));
          // 试卷宝弹窗曝光
          showPctestpaperPopupBlank(traceInfo())
    }
};

// 获取弹窗信息
const getPopConfig = () => {
  userInfo.value = isLogin()
  if(userInfo.value){
      queryPopConfig({
      equit_type:2,
      show_page:1,
      client_type:3
    }).then((res) => {
      console.log(res,'popInfo');
      expireInfo.value = res.data;
      // res.data.img = '123123'
      if(res.data.img) {
          canShowDialog.value = true;
          isShowRemindPop();
      }else{
        canShowDialog.value = false;
      }
    }).catch((err) => {
      console.log(err,'popErr');
      canShowDialog.value = false;
    })
  }else{
    canShowDialog.value = false;
  }
}

// 打开会员购买弹窗
const openHandler = () => {
  canShowDialog.value = false;

  store.dispatch('openVipDialog')
  // 试卷宝弹窗了解更多
  clickPctestpaperPopupSee(traceInfo())
}
// 关闭会员购买
const closeHandler = () => {
  canShowDialog.value = false;
  // 试卷宝弹窗关闭
  clickPctestpaperPopupClose(traceInfo())
}
// 是否展示弹窗
const onShowBanner = () => {
  // 基准时间 2023.7.01,每展示三天隐藏三天，以此类推，使用dayjs
  const baseTime = dayjs('2023-07-01 00:00:00')

  const nowTime = dayjs()
  // 判断当前时间是否在baseTime之前,如果在之前则不展示
  const isBefore = nowTime.isBefore(baseTime)
  if(isBefore) {
    showBanner.value = false
    return false
  }
  console.log('isBefore', isBefore);

  const diffTime = nowTime.diff(baseTime, 'day')
  console.log('diffTime', diffTime);
  const showTime = diffTime % 6
  showBanner.value = showTime < 3;

  return showTime < 3
}

onMounted(async () => {
  defaultKeyWord.value = decodeURIComponent(outKeyword as string);
  // 获取年级和字典数据
  getGradeAndDictionaryData();

  // 走简化购买会员弹窗会员支付逻辑时，不展示会员过期提醒弹窗
  const isDirectPay = window.sessionStorage.getItem('isDirectPay');
  if (!isDirectPay) {
    getPopConfig()
  }
  onShowBanner()
});
watch(
  () => finalQueryParams.value,
  (newVal, oldVal) => {
    window.localStorage.setItem("queryParamsData", JSON.stringify(newVal));
    console.log(newVal, "finalQueryParams.value");
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Search, {
            defaultFilterData: defaultSubject.value,
            onHandleSelectSubject: handleSelectSubject,
            onSearch: handleSearch,
            keyWord: defaultKeyWord.value,
            pageFrom: "home",
            subjectData: dictionary.value?.subject
          }, null, 8, ["defaultFilterData", "keyWord", "subjectData"]),
          _createVNode(Filter, {
            selectedSubject: selectedSubject.value,
            gradeList: gradeList.value,
            gradeClassifyDefault: gradeClassifyDefault.value,
            onParamsChangeListenter: paramsChangeListenter,
            dictionary: dictionary.value
          }, null, 8, ["selectedSubject", "gradeList", "gradeClassifyDefault", "dictionary"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                (noData.value || loadWrong.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (noData.value)
                        ? (_openBlock(), _createBlock(NoData, {
                            key: 0,
                            tipText: ['抱歉,没有找到您查询的试卷', '调整上方的筛选条件可以找到更多试卷']
                          }))
                        : _createCommentVNode("", true),
                      (loadWrong.value)
                        ? (_openBlock(), _createBlock(LoadWrong, {
                            key: 1,
                            onReloadPage: _cache[0] || (_cache[0] = () => getPaperList(currentPage.value))
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (!noData.value && !loadWrong.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paperList.value, (item, index) => {
                        return (_openBlock(), _createBlock(paperItem, {
                          onOnItemClick: handleItemClick,
                          class: _normalizeClass(!index ? 'no-border' : ''),
                          key: `paper-${item?.id}-${index}`,
                          data: item
                        }, null, 8, ["class", "data"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_loading, isLoading.value]
              ]),
              (maxPage.value > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_el_pagination, {
                      background: true,
                      onCurrentChange: handleCurrentChange,
                      "current-page": currentPage.value,
                      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
                      "page-size": pageSize.value,
                      layout: layout.value,
                      "prev-text": "上一页",
                      "next-text": "下一页",
                      total: total.value
                    }, null, 8, ["current-page", "page-size", "layout", "total"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(UserMember, { pageName: "试卷宝主页" }),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(RankList, {
                  from: "homePage",
                  selectParams: finalQueryParams.value,
                  onDetail: onRankDetail,
                  entrance: "试卷宝主页"
                }, null, 8, ["selectParams"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(MultiPaperDetail, {
      show: showMultiPaperDetail.value,
      "pack-paper-info": packPaperInfo,
      "pack-paper-list": packPaperList.value,
      onOnClose: handleCloseMultiPaperDetail
    }, null, 8, ["show", "pack-paper-info", "pack-paper-list"]),
    (canShowDialog.value)
      ? (_openBlock(), _createBlock(ExpireLottie, {
          key: 0,
          lottiePath: expireInfo.value.img,
          onOpenHandler: openHandler,
          onCloseHandler: closeHandler
        }, null, 8, ["lottiePath"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})